var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe396(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8c8e8e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-173 -166)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(173 166)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.046,0a7.046,7.046,0,1,0,7.046,7.046A7.054,7.054,0,0,0,7.046,0Zm0,12.791a5.745,5.745,0,1,1,5.745-5.745A5.752,5.752,0,0,1,7.046,12.791Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.97 10.97)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M355.885,354.965l-3.729-3.729a.65.65,0,0,0-.92.92l3.729,3.729a.65.65,0,0,0,.92-.92Z",
    transform: "translate(-351.046 -351.046)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-.72-1.8V-4.77H-3.33V-6.03H-.72V-9H.72v2.97H3.33v1.26H.72V-1.8Z",
    transform: "translate(180 178)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe396);
export default __webpack_public_path__ + "static/media/Groupe_396.c09347793ae42070e4aeb3c0228cb52a.svg";
export { ForwardRef as ReactComponent };